var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-center items-center min-h-screen text-gray-500"},[_vm._v(" Signing out… ")])
}
var staticRenderFns = []

export { render, staticRenderFns }